// extracted by mini-css-extract-plugin
module.exports = {"popover":"popover_popover__10lGi"};